import { FireIcon } from 'components'
import { CircleIcon, DashedCircleIcon, HeroIconProps } from 'components/icons'
import { LeadTemperature } from 'types'

export interface Props extends HeroIconProps {
  value?: LeadTemperature
}

export default function LeadTempIcon({ value, ...rest }: Props) {
  switch (value) {
    case 'hot':
      return <FireIcon size="sm" color="rgba(232, 58, 90, 1)" {...rest} />
    case 'warm':
      return (
        <CircleIcon
          size="sm"
          fill="rgba(232, 194, 58, 1)"
          color="rgba(232, 194, 58, 1)"
          {...rest}
        />
      )
    case 'cold':
      return (
        <CircleIcon
          size="sm"
          fill="rgba(119, 182, 255, 1)"
          color="rgba(119, 182, 255, 1)"
          {...rest}
        />
      )
    default:
      return <DashedCircleIcon color="rgba(0, 0, 0, 0.6)" size="sm" {...rest} />
  }
}
